import {createContext} from 'react';
//types
import {IOrganizationAuctionResponse} from '@/utils/types';

export type AuctionDetailsContextType = {
	editableAuction: IOrganizationAuctionResponse | null;
	onCloseModal: () => void;
};

export const AuctionDetailsContext = createContext({} as AuctionDetailsContextType);
